import extractErrorMessage from '../../../shared/utils/extractErrorMessage';
import { authClient } from '../../../shared/api/client';

const isOkStatus = (status) => status >= 200 && status < 300;

export const fetchSenders = async ({ page = 1, limit = 10, search = null }) => {
  try {
    let query = `?page=${page}&limit=${limit}`;
    if (search) {
      query += `&search=${encodeURIComponent(search)}`;
    }

    const response = await authClient.get(`/senders${query}`);
    return {
      data: response.data,
      status: response.status,
      ok: isOkStatus(response.status),
      message: response.data?.message || null,
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Doslo je do greske pri dobavljanju posiljalaca.'
    );
    return {
      data: null,
      status: error?.response?.status || null,
      ok: false,
      message,
    };
  }
};

export const fetchSenderOptions = async () => {
  try {
    const response = await authClient.get('/senders/options');
    return {
      data: Array.isArray(response.data) ? response.data : [],
      status: response.status,
      ok: isOkStatus(response.status),
      message: null,
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Doslo je do greske pri dobavljanju posiljalaca.'
    );
    return {
      data: null,
      status: error?.response?.status || null,
      ok: false,
      message,
    };
  }
};

export const createSender = async (payload) => {
  try {
    const response = await authClient.post('/senders', payload);
    return {
      data: response.data,
      status: response.status,
      ok: isOkStatus(response.status),
      message: response.data?.message || 'Posiljalac kreiran.',
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Doslo je do greske pri kreiranju posiljaoca.'
    );
    return {
      data: null,
      status: error?.response?.status || null,
      ok: false,
      message,
    };
  }
};

export const updateSender = async (id, payload) => {
  try {
    const response = await authClient.put(`/senders/${id}`, payload);
    return {
      data: response.data,
      status: response.status,
      ok: isOkStatus(response.status),
      message: response.data?.message || 'Posiljalac azuriran.',
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Doslo je do greske pri azuriranju posiljaoca.'
    );
    return {
      data: null,
      status: error?.response?.status || null,
      ok: false,
      message,
    };
  }
};

export const deleteSender = async (id) => {
  try {
    const response = await authClient.delete(`/senders/${id}`);
    return {
      data: response.data,
      status: response.status,
      ok: isOkStatus(response.status),
      message: response.data?.message || 'Posiljalac obrisan.',
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Doslo je do greske pri brisanju posiljaoca.'
    );
    return {
      data: null,
      status: error?.response?.status || null,
      ok: false,
      message,
    };
  }
};
